var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
class t {
  constructor() {
    __publicField(this, "state");
    __publicField(this, "listeners");
    this.state = null, this.listeners = [];
  }
  getState() {
    return this.state;
  }
  setState(t2) {
    this.state = t2, this.notifyListeners();
  }
  addListener(t2) {
    this.listeners.push(t2);
  }
  removeListener(t2) {
    this.listeners = this.listeners.filter((s) => s !== t2);
  }
  notifyListeners() {
    this.listeners.forEach((t2) => t2(this.state));
  }
}
export {
  t as default
};
//# sourceMappingURL=stateManager.js.map
